import React, { useState, useCallback, useEffect, RefObject } from "react";
import { isMobile } from "react-device-detect";
import fscreen from "fscreen";
import styles from "./styles.module.scss";
import DeviceService from "../../DeviceService";

interface FullscreenToggleProps extends React.HTMLAttributes<HTMLDivElement> {
    target?: RefObject<HTMLElement>;
    isFullscreenEnabled?: Boolean;
}

export const FullscreenToggle: React.FC<FullscreenToggleProps> = ({ target, isFullscreenEnabled, ...props }) => {
    const rootContainer = document.body;

    const [isActive, setIsActive] = useState<boolean>(
        !!fscreen.fullscreenElement && fscreen.fullscreenElement === rootContainer
    );

    const isReplay = window.location.href.includes('replay-');
    const isIPhoneSafari = DeviceService.isIphone() && DeviceService.isSafari();

    useEffect(() => {
        if (isIPhoneSafari) {
            const hideBars = () => {
                document.body.style.height = `${window.innerHeight + 1}px`;
                setTimeout(() => {
                    window.scrollTo(0, 1);
                }, 100);
            };
            document.querySelectorAll('html, body').forEach(element => {
                if (element instanceof HTMLElement) element.style.overscrollBehavior = '';
            });
            hideBars();
            window.addEventListener("resize", hideBars);

            return () => {
                window.removeEventListener("resize", hideBars);
            };
        }
    }, []);

    const handleFullscreenChange = useCallback(() => {
        setIsActive(fscreen.fullscreenElement === rootContainer);
    }, [rootContainer]);

    useEffect(() => {
        window.addEventListener("fullscreenchange", handleFullscreenChange);
        return () => {
            window.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, [handleFullscreenChange]);

    const enterFullscreen = useCallback(() => {
        if (fscreen.fullscreenElement) {
            // @ts-expect-error taken from previous, check after
            return fscreen.exitFullscreen().then(() => fscreen.requestFullscreen(rootContainer));
        }
        return fscreen.requestFullscreen(rootContainer as Element);
    }, [rootContainer]);

    if (!isFullscreenEnabled || !isMobile || !fscreen.fullscreenEnabled || isIPhoneSafari || isReplay) {
        return null;
    }

    if (isActive) {
        return null;
    }

    return (
        <div className={styles.fullscreenToggle} onClick={enterFullscreen} {...props}>
            <div className={styles.background}></div>
            <div className={styles.foreground}>
                <img src={require("./tap.png")}/>
            </div>
        </div>
    );
};
